export const parseStarQueryParam = (starParam: string): Array<number> => {
  const splitKey = /,/.test(starParam) ? ',' : '%2C';

  return starParam
    .split(splitKey)
    .map((star) => Number(star))
    .filter((val) => !Number.isNaN(val));
};

export default parseStarQueryParam;
